// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"118":"740d5955","126":"e09e1fdf","320":"2e18802b","452":"7ff1c3e3","608":"d5daece8","693":"e8eb6a24","787":"fdb1cf78","987":"3a8a07c4","997":"a7262ecc"}[chunkId] + ".chunk.js";
};